import { render, staticRenderFns } from "./PmsOrderManager.vue?vue&type=template&id=7410857d"
import script from "./PmsOrderManager.vue?vue&type=script&lang=js"
export * from "./PmsOrderManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports